import React from "react";
import { Link } from "react-router-dom";
import InArticleAd from "../../Ads/inArticleAd";

const CategoryCourseCard = (props) => {
  const {
    // id,
    title,
    slug,
    // lesson,
    rating,
    students,
    // duration,
    category,
    isOffered,
    // isFeatured,
    // courseCode,
    imgUrl,
    // instructor,
    enrollNow,
    // description,
    modules,
  } = props.course;

  return (
    <article className="course">
      <div className="course__img">
        <img
          width={100}
          height={100}
          loading="lazy"
          src={`/${imgUrl}`}
          srcSet={`
    /${imgUrl} 480w,
    /${imgUrl} 800w,
    /${imgUrl} 1200w,
    /${imgUrl} 1600w
  `}
          sizes="(max-width: 600px) 480px, 
         (max-width: 1200px) 800px, 
         1200px"
          className="block w-full aspect-[1/1]"
          alt={title}
          title={title}
        />
      </div>
      <div className="course__title">
        <h3>{title}</h3>
      </div>
      <div className="course__detail">
        <div className=" d-flex justify-content-between align-items-center">
          <p className="lesson d-flex align-items-center gap-1">
            <i className="ri-list-check"></i>{" "}
            {category !== undefined && category !== ""
              ? category.toUpperCase()
              : "NA"}
          </p>
          <p className="students d-flex align-items-center gap-1">
            <i className="ri-book-open-line"></i>
            {isOffered ? `${modules.length} Weeks` : "NA"}
          </p>
        </div>
        <InArticleAd />
        <div className=" d-flex justify-content-between align-items-center">
          <p className="students d-flex align-items-center gap-1">
            <i className="ri-user-line"></i> {isOffered ? students : "NA"}
          </p>
          <p className="rating d-flex align-items-center gap-1">
            <i className="ri-star-fill"></i> {isOffered ? rating : "NA"}
          </p>
        </div>
        <div className=" d-flex justify-content-between align-items-center">
          <Link
            to={isOffered ? `/courses/${category}/${slug}` : "#"}
            target="_parent"
            className={`detail  ${isOffered ? "" : ".disabled-link"}`}
          >
            {isOffered ? "Details" : "Coming Soon"}
          </Link>
          <Link
            to={isOffered ? enrollNow : "#"}
            target="_blank"
            className={`enroll ${isOffered ? "" : ".disabled-link"}`}
          >
            {isOffered ? "Enroll Now" : "Coming Soon"}
          </Link>
        </div>
      </div>
    </article>
  );
};

export default CategoryCourseCard;
